<script setup lang="ts">
import { RouterView } from 'vue-router'
import BottomNav from './components/BottomNav.vue'
import NetworkStatus from './components/NetworkStatus.vue'
import ReloadPrompt from './components/ReloadPrompt.vue'
import { useAuthStore } from './stores/auth'

import { onMounted } from 'vue'
import Swal from 'sweetalert2';
const authStore = useAuthStore()

onMounted(async () => {
  if (authStore.isAuthenticated) {
    authStore.initFcm()
  }

  // Frontend Notification Listener
  try {
    const { onMessageListener } = await import('./firebase');
    onMessageListener().then((payload: any) => {
      console.log('Foreground notification:', payload);
      // Simple alert or custom toast
      // For now, let's use browser Notification API if permission granted, otherwise alert
      const title = payload?.notification?.title || 'Notification';
      const body = payload?.notification?.body || '';
      
      if (Notification.permission === 'granted') {
         // new Notification(title, { body }); // Browser notification
         // Optional: still show Swal if user is inside the app
         Swal.fire({
            title: title,
            text: body,
            icon: 'info',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 4000
         });
      } else {
         Swal.fire({
             title: title,
             text: body,
             icon: 'info',
             confirmButtonText: 'OK'
         });
      }
    }).catch(err => console.log('failed: ', err));
  } catch (e) {
    console.log('Firebase not supported or error', e);
  }
})

</script>

<template>
  <div class="min-h-screen bg-gradient-soft text-slate-800 font-sans selection:bg-primary/20">
    <NetworkStatus />
    <ReloadPrompt />
    <RouterView v-slot="{ Component }">
      <Transition name="fade" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
    <BottomNav v-if="authStore.isAuthenticated && !$route.meta.hideBottomNav" />
  </div>
</template>
